import { createFileRoute } from "@tanstack/react-router";
import { NanaeHeader, NanaeFooter } from "@/components/qv3/NanaeShared";
import { LegalSection } from "@/components/qorum/LegalSection";
import { socialMeta, pageJsonLd } from "@/lib/seo-meta";

export const Route = createFileRoute("/mentions-legales")({
  head: () => ({
    meta: [
      { title: "Mentions légales — Hōjin" },
      {
        name: "description",
        content:
          "Mentions légales de Hōjin (UDITEK SAS) : éditeur, directeur de la publication, hébergeur et propriété intellectuelle.",
      },
      { name: "robots", content: "noindex, follow" },
      ...socialMeta({
        title: "Mentions légales — Hōjin",
        description: "Mentions légales de Hōjin (UDITEK SAS) : éditeur, directeur de la publication, hébergeur et propriété intellectuelle.",
        url: "https://hojin.ai/mentions-legales",
        image: "conseil",
        card: "summary",
      }),
    ],
    links: [{ rel: "canonical", href: "https://hojin.ai/legal" }],
    scripts: pageJsonLd({
      path: "/mentions-legales",
      name: "Mentions légales — Hōjin",
      description: "Mentions légales de Hōjin (UDITEK SAS) : éditeur, directeur de la publication, hébergeur et propriété intellectuelle.",
      type: "WebPage",
      image: "conseil",
      breadcrumb: [{ name: "Mentions légales", path: "/mentions-legales" }],
    }),
  }),
  component: MentionsLegalesPage,
});

const SECTIONS = [
  {
    title: "Éditeur du site",
    body: (
      <>
        <p>
          Le site Hōjin est édité par <strong>UDITEK SAS</strong>, [FORME] au
          capital de [CAPITAL] €, dont le siège social est situé [ADRESSE],
          immatriculée au RCS de [VILLE] sous le numéro [SIREN], TVA
          intracommunautaire [TVA].
        </p>
        <p>Contact : [EMAIL].</p>
      </>
    ),
  },
  {
    title: "Directeur de la publication",
    body: (
      <p>
        [NOM du directeur de la publication], en sa qualité de représentant
        légal d'UDITEK SAS.
      </p>
    ),
  },
  {
    title: "Hébergeur",
    body: (
      <p>
        Le site est hébergé par [HÉBERGEUR — raison sociale, adresse complète,
        contact]. (À confirmer selon l'infrastructure servant hojin.ai :
        Railway, Lovable, CDN.)
      </p>
    ),
  },
  {
    title: "Propriété intellectuelle",
    body: (
      <p>
        L'ensemble des éléments du site (textes, identité visuelle, code) est
        protégé par le droit de la propriété intellectuelle. Toute reproduction
        non autorisée est interdite.
      </p>
    ),
  },
];

export function MentionsLegalesPage() {
  return (
    <div className="nanae-page" style={{ background: "var(--ivory)", minHeight: "100vh" }}>
      <NanaeHeader title="Mentions légales" variant="public" />
      <section
        aria-label="Mentions légales"
        style={{ maxWidth: 720, margin: "0 auto", padding: "64px 32px 80px" }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 20,
          }}
        >
          <span
            aria-hidden
            style={{ width: 24, height: 0.5, background: "var(--accent-cramoisi)", display: "inline-block" }}
          />
          <span
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              color: "var(--gold-deep)",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            Mentions · Volume MMXXVI
          </span>
        </div>
        <h1
          style={{
            fontFamily: '"Anton", sans-serif',
            fontWeight: 400,
            fontSize: 64,
            color: "var(--charcoal)",
            letterSpacing: "-1.5px",
            textTransform: "uppercase",
            lineHeight: 0.95,
            margin: "0 0 32px",
          }}
        >
          Mentions légales
        </h1>
        <LegalSection articles={SECTIONS} />
      </section>
      <NanaeFooter variant="full" />
    </div>
  );
}
